<template>
    <div>
        <ul class="tool">
            <!-- <li @click="toggleSelector" :class="{ 'active': toggleSelector }" title="选择"> <i class="iconfont iconxuanze"></i> </li> -->
            <li @click.stop="toggleMeasure" :class="{ 'active': enableMeasure }" title="测量" v-if="measureData.length > 0"> <i class="iconfont iconceliang_yulan"></i></li>
            <li @click.stop="focusObject" title="聚焦物体"> <i class="iconfont iconjujiao"></i> </li>
            <li @click.stop="toggleRoma" :class="{ 'active': showRoma }" title="漫游"> <i class="iconfont iconmanbu"></i> </li>
            <!-- <li @click.stop="toggleFly" :class="{ 'active': enableFly }" title="飞行" v-if="flyData.length > 0"> <i class="iconfont iconfeihanglujing"></i> </li> -->
        </ul>

        <ul class="fly_list" v-show="showFlyList">
            <li v-for="(item, index) in flyLines" :key="item.id" :class="{active: index == currentIndex}" @click="itemSelectHandler(item.id)"><i>{{index + 1}}</i> 路线{{index + 1}}</li>
        </ul>

        <!-- 飞行设置 -->
        <div class="fly_menu" v-if="flySetting.show && enableFly" >
            <el-button v-if="isPaused == 0" @click.stop="startFly" type="primary" round>开始飞行</el-button>
            <el-button v-if="isPaused == 1" @click.stop="pauseFly" type="primary" round>暂停飞行</el-button>
            <el-button v-if="isPaused == 2" @click.stop="resumeFly" type="primary" round>恢复飞行</el-button>
            <el-button v-if="isPaused != 0" @click.stop="endFly" round class="btn_1">结束飞行</el-button>
        </div>

        <!-- 漫游 -->
        <roma v-if="showRoma" :showEdit="false" :flyData="flyData" @exit="showRoma = false"></roma>
    </div>
</template>

<script>
import BusEvent from '@/busEvent'
import Roma from '../Editor/Roma.vue'
import _ from 'lodash'

var mapMeasure, 
    mapFlyEditor

export default{

    components: {
        Roma
    },

    props: {
        measureData: {
            default: []
        },
        flyData: {
            default: []
        }
    },

    data(){
        return {
            enableMeasure: false,
            enableFly: false,
            flySetting: {
                show: false,
                selected: ''
            },
            viewMode: '3d',
            isPaused: 0,
            focusIndex: 0,
            showFlyList: false,
            flyLines: [],
            currentIndex: null,
            showRoma: false
        }
    },

    watch: {
        flyData( val ){
            mapFlyEditor.setData( val )
        }
    },

    mounted(){
        this.init()
    },
    
    beforeDestroy(){
        document.removeEventListener( 'keydown', this.deleteHandler )
    },

    computed: {
        viewer(){
            return window.viewer
        }
    },

    methods: {

        init(){
            //监听键盘删除/查找键
            this.deleteHandler = this.keydownHandler.bind(this)
            document.addEventListener( 'keydown', this.deleteHandler )

            this.$bus.$on( BusEvent.ToolChange, this.onButtonChange.bind(this) )
            mapMeasure = new AMRT.MapMeasure( this.viewer )
            mapMeasure.onSelect = selected => {
                mapMeasure.remove( selected )
            }

            mapFlyEditor = new AMRT.MapFlyEditor( this.viewer )
            //选中路线弹出预览窗口
            mapFlyEditor.onSelect = selected => {
                //选中路线  直接开启飞行
                this.flySetting.selected = selected.id
                this.showFlyList = false
                this.startFly()
            }
        },

        /**
         * 菜单切换重置功能
         */
        onButtonChange(){
            if( this.enableMeasure ){
                mapMeasure.clear()
                this.enableMeasure = false
            }

            if( mapFlyEditor.isFlying ){
                mapFlyEditor.end()
            }

            if( this.enableFly ){
                this.enableFly = false
                this.flySetting.show = false
                this.showFlyList = false
                mapFlyEditor.enable = false
                mapFlyEditor.clear()
            }
        },


        /**
         * 显示/隐藏 测量数据
         */
        toggleMeasure(){
            if( this.enableMeasure ){
                this.$bus.$emit( BusEvent.ToolChange )
            }else{
                this.$bus.$emit( BusEvent.ToolChange )
                this.enableMeasure = true
                mapMeasure.load( this.measureData )
            }
        },

        /**
         * 循环聚焦
         */
        focusObject(){
            var m = this.viewer.selectedObject
            if( m.length > 0 ){
                this.viewer.controls.fit( m[0] )
            }else{
                // let group = this.viewer.modelGroup.children.filter( item => item.isSceneModel )
                // group = group.concat( this.viewer.modelGroup.children )
                // group = group.concat( this.viewer.gisGroup.children )
                let group = this.viewer.gisGroup.children
                if( this.focusIndex === undefined || this.focusIndex >= group.length ) this.focusIndex = 0
                if( group.length > 0 ) m = group[ this.focusIndex ]
                this.focusIndex ++
                if( m ){
                    this.viewer.controls.fit( m )
                    setTimeout(() => {
                        this.viewer.gisManager.cameraChangeHandler()
                        if( m.isLargeScene ) m.loader.detect()
                    }, 500)
                }else{
                    this.$message.info('场景中无物体')
                }
            }
        },

        toggleRoma(){
            this.$bus.$emit( BusEvent.ToolChange )
            this.showRoma = !this.showRoma
        },


        /**
         * 点击飞行按钮
         */
        toggleFly(){
            if( this.enableFly ){
                this.enableFly = false
                mapFlyEditor.clear()
                this.showFlyList = false
            }else{
            this.$bus.$emit( BusEvent.ToolChange )
                mapFlyEditor.load()
                this.flyLines = this.viewer.mapFlyEditor.data
                this.enableFly = true
                this.showFlyList = true
            }
        },

        /**
         * 选择飞行列表路径
         */
        itemSelectHandler( selected ){
            this.flySetting.selected = selected
            this.showFlyList = false
            this.startFly()
        },

        /**
         * 开始飞行
         */
        startFly(){
            this.isPaused = 1
            this.flySetting.show = true
            mapFlyEditor.start( this.flySetting.selected )
        },


        /**
         * 结束飞行
         */
        endFly(){
            this.isPaused = 0
            this.flySetting.show = false
            this.showFlyList = true
            mapFlyEditor.end()
        },

        /**
         * 暂停飞行
         */
        pauseFly(){
            this.isPaused = 2
            mapFlyEditor.pause()
        },

        /**
         * 恢复飞行
         */
        resumeFly(){
            this.isPaused = 1
            mapFlyEditor.resume()
        },

        /**
         * 键盘点击F查找
         */
        keydownHandler( e ){
            if( e.key == 'f' ){
                this.focusObject()
            }
        }

    }

}
</script>

<style lang="scss" scoped>
.tool{
    position: fixed; left: 45px; bottom: 60px;
    li{
        width: 54px; height: 54px; border-radius: 50%; background-color: #fff; box-shadow: 0 0 10px #2F2F2F; display: flex; justify-content: center; align-items: center; margin: 16px 0; cursor: pointer;
        .iconfont{ font-size: 22px; color: #1458EA; }
    }
    .active{
        background-color: #1458EA;
        .iconfont{ color: #FFFFFF; }
    }
}
.fly_menu{
    position: absolute; z-index: 1; width: 160px;padding: 10px 0; border-radius: 10px;  display: flex; flex-direction: column; align-items: center; right: 40px; bottom: 40px;
    /deep/ .el-button{
        margin-top: 10px; width: calc(100% - 40px); height: 34px;
        span{
            position: relative; top: -2px;
        }
    }
    /deep/ .el-button--primary{
        background-color: #1458EA;
        border-color: #1458EA;
    }
    .btn_1{ color: #1458EA; border-color: #1458EA; margin: 10px 0; }
}
.fly_list{
    width: 120px; height: 192px; padding: 5px 0; overflow-x: hidden; overflow-y: scroll; position: fixed; left: 114px; bottom: 70px;  background-color: rgba(255,255,255,0.5); border-radius: 4px;
    li{
        font-size: 14px; color:#182C49; height: 32px; line-height: 32px; cursor: pointer; padding: 0 10px;
        i{ display: inline-block; margin: 0 10px; width: 20px; height: 20px; line-height: 20px; text-align: center; font-style: normal; border-radius: 12px; background-color: #1458EA; color: #FFF; font-size: 10px; }
        &:hover{ background-color: #eee; }
    }
    .active{
        i{ background-color: #FF8D30; }
    }
}

</style>
